import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from "@angular/common/http";

import { MessageService } from "./message/message.service";
import { SharedService } from "./services/shared.service";
import { WebserviceService } from "./services/webservice.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from './services/common.service';
import { RouterModule } from '@angular/router';

// ngx-bootstrap
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { PusherService } from './services/pusher.service';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LoaderComponent } from '../layout/loader/loader.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ChangePasswordComponent } from '../pages/change-password/change-password.component';
import { StakesComponent } from '../pages/stakes/stakes.component';
import { TopnavComponent } from '../layout/topnav/topnav.component';
import { LoginComponent } from '../auth/login/login.component';
import { BetListComponent } from '../pages/msports/bet-list/bet-list.component';
import { FilterPipe } from './pipes/filter.pipe';
import { MyBetListComponent } from '../pages/my-bet-list/my-bet-list.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { CasinoComponent } from '../pages/dashboard/casino/casino.component';
import { BetSlipComponent } from '../pages/msports/bet-slip/bet-slip.component';
import { UpcomingComponent } from '../layout/upcoming/upcoming.component';
import { SafeURLPipe } from './pipes/safe-url.pipe';
import { LoginPage1Component } from '../auth/login-page1/login-page1.component';
import { CasinoBannerComponent } from '../pages/casino-banner/casino-banner.component';



@NgModule({
  declarations: [
    SafeHtmlPipe,
    SafeURLPipe,
    LoaderComponent,
    ChangePasswordComponent,
    StakesComponent,
    TopnavComponent,
    LoginComponent,
    BetListComponent,
    FilterPipe,
    MyBetListComponent,
    FooterComponent,
    CasinoComponent,
    BetSlipComponent,
    UpcomingComponent,
    LoginPage1Component,
    CasinoBannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: false,
      progressBar: true,
      maxOpened: 1,
      autoDismiss: true,
      enableHtml: true
    }),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    AccordionModule.forRoot(),
    LazyLoadImageModule
  ],
  exports: [
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule,
    ModalModule,
    TabsModule,
    CollapseModule,
    TooltipModule,
    TypeaheadModule,
    SafeHtmlPipe,
    SafeURLPipe,
    LoaderComponent,
    ChangePasswordComponent,
    StakesComponent,
    TopnavComponent,
    LoginComponent,
    BetListComponent,
    FilterPipe,
    MyBetListComponent,
    FooterComponent,
    CasinoComponent,
    BetSlipComponent,
    UpcomingComponent,
    LoginPage1Component,
    CasinoBannerComponent,
    LazyLoadImageModule,
    AccordionModule
  ],
  providers: [MessageService, SharedService, WebserviceService, CommonService, {
    provide: ToastrService
  }],
})
export class SharedModule { }
